var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIconBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4261 9.37409C16.4144 10.5469 16.1088 11.698 15.5373 12.7222C14.8871 13.9101 13.9103 14.8869 12.7224 15.537C11.3662 16.2654 9.80826 16.5284 8.28803 16.2856C6.7678 16.0429 5.36929 15.3077 4.30731 14.1932C3.24533 13.0786 2.57858 11.6463 2.40949 10.1161C2.24039 8.58591 2.57829 7.04253 3.37128 5.72299C4.16428 4.40344 5.36852 3.3807 6.79906 2.81184C8.2296 2.24298 9.80733 2.15946 11.2899 2.57411C12.7725 2.98875 14.078 3.87863 15.0059 5.10708C15.9338 6.33553 16.4327 7.83461 16.4261 9.37409Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0706 18.0704C17.8888 18.2539 17.6724 18.3995 17.434 18.4988C17.1956 18.5982 16.9399 18.6493 16.6817 18.6493C16.4234 18.6493 16.1677 18.5982 15.9293 18.4988C15.6909 18.3995 15.4746 18.2539 15.2928 18.0704L12.7224 15.5371C13.9103 14.8869 14.8871 13.9102 15.5372 12.7223L18.0706 15.263C18.2585 15.4453 18.4079 15.6635 18.51 15.9046C18.612 16.1458 18.6646 16.4049 18.6646 16.6667C18.6646 16.9286 18.612 17.1877 18.51 17.4288C18.4079 17.67 18.2585 17.8881 18.0706 18.0704V18.0704Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9668 9.06297C5.9668 8.24178 6.29301 7.45423 6.87368 6.87356C7.45435 6.29289 8.2419 5.96667 9.06309 5.96667",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIconBtn);
export default __webpack_public_path__ + "static/media/search-icon-btn.7fb6ba79a54f75d96733fb77c660dcc3.svg";
export { ForwardRef as ReactComponent };